import Fuse from 'fuse.js';

import { type Brain } from '@/shared/types/brain';

import { getBrainIcon } from '../../icons';
import { type EntityResult } from '../../types';
import { MAX_PER_TYPE } from '../../utils';

/**
 * Searches AI agents (brains) using a pre-built Fuse instance.
 * Returns up to MAX_PER_TYPE results sorted by fuzzy match score.
 */
export const searchBrains = (query: string, fuse: Fuse<Brain> | null): EntityResult[] => {
  if (!fuse) {
    return [];
  }

  return fuse
    .search(query, { limit: MAX_PER_TYPE })
    .map(({ item: b, score }) => ({
      id: b.brain_id,
      name: b.name,
      type: 'ai_agent' as const,
      path: `/ai-agents/${b.brain_id}/overview`,
      icon: getBrainIcon(b.brain_type),
      score: 1 - (score ?? 0),
    }));
};
